import { loc } from "../i18n/survey";

enum HearAboutUs {
  Youtube = "Youtube",
  ChatGPTAISearch = "ChatGPT/AI Search",
  ArticleBlog = "ArticleBlog",
  FacebookInstagram = "FacebookInstagram",
  TikTok = "TikTok",
  FriendsFamily = "FriendsFamily",
  Other = "Other",
}

const hearaboutusQuestion = {
  name: "hearaboutus",
  title: loc("quiz.hearaboutus.title"),
  type: "radiogroup",
  choices: [
    {
      value: HearAboutUs.Youtube,
      text: "Youtube",
    },
    {
      value: HearAboutUs.ChatGPTAISearch,
      text: loc("quiz.hearaboutus.choices.aiSearch"),
    },
    {
      value: HearAboutUs.ArticleBlog,
      text: loc("quiz.hearaboutus.choices.articleBlog"),
    },
    {
      value: HearAboutUs.FacebookInstagram,
      text: `Facebook / Instagram`,
    },
    {
      value: HearAboutUs.TikTok,
      text: "TikTok",
    },
    {
      value: HearAboutUs.FriendsFamily,
      text: loc("quiz.hearaboutus.choices.friendsFamily"),
    },
    {
      value: HearAboutUs.Other,
      text: loc("quiz.shared.other"),
    },
  ],
  isRequired: true,
};

export { HearAboutUs, hearaboutusQuestion };
